import React from "react";
import { useParams } from "react-router-dom";
import { findCategory, findService, findZone } from "@/data/pages";
import CategoryPage from "@/pages/CategoryPage";
import ServicePage from "@/pages/ServicePage";
import ZonePage from "@/pages/ZonePage";
import NotFound from "@/pages/NotFound";

export default function SlugRouter() {
  const { slug } = useParams();
  if (findCategory(slug)) return <CategoryPage />;
  if (findService(slug)) return <ServicePage />;
  if (findZone(slug)) return <ZonePage />;
  return <NotFound />;
}
